import { RECORD_VALUESET_URLS } from '@/constants';
import { gql } from '@apollo/client';
import { TASK_FIELDS } from '@/graphql/queries/record-management/fragment';
export const QA_AUDIT_QUERY = gql`
  query AuditEvent($type: String, $_count: Int, $_offset: Int) {
    AuditEventList(type: $type, _count: $_count, _offset: $_offset) {
      id
      period {
        start
        end
      }
      agent {
        type {
          coding {
            code
            display
            system
          }
        }
        role {
          coding {
            code
            display
            system
          }
        }
        who {
          reference
          resource {
            ... on Patient {
              id
              name {
                prefix
                family
                given
              }
            }
            ... on Practitioner {
              id
              name {
                prefix
                family
                given
              }
              practitionerRole: PractitionerRoleList(_reference: practitioner) {
                code {
                  coding {
                    system
                    code
                    display
                  }
                }
                specialty {
                  coding {
                    system
                    code
                    display
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const AUDIT_LOG_QUERY = gql`
  query AuditEvent($subtype: String, $_count: Int, $_offset: Int) {
    AuditEventList(subtype: $subtype, _count: $_count, _offset: $_offset) {
      id
      period {
        start
        end
      }
      subtype {
        code
        display
        system
      }
      entity {
        what {
          reference
        }
        type {
          code
          display
          system
        }
        detail {
          type
          valueString
        }
      }
      agent {
        type {
          coding {
            code
            display
            system
          }
        }
        role {
          coding {
            code
            display
            system
          }
        }
        requestor
        who {
          reference
          resource {
            ... on Patient {
              id
              name {
                prefix
                family
                given
              }
            }
            ... on Practitioner {
              id
              name {
                prefix
                family
                given
              }
              practitionerRole: PractitionerRoleList(_reference: practitioner) {
                code {
                  coding {
                    system
                    code
                    display
                  }
                }
                specialty {
                  coding {
                    system
                    code
                    display
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const RECORD_TYPES_QUERY = gql`
  query ValueSets {
        medicalRecordCategories: ValueSetList(url: "${RECORD_VALUESET_URLS.MEDICAL_RECORD_CATEGORIES}") {
          id
          compose {
            include {
              concept {
                code
                display
              }
            }
          }
        }
    }
  `;
export const DOC_REF_QUERY = gql`
  query DocRef($id: ID!) {
    DocumentReference(id: $id) {
      meta {
        tag {
          code
        }
      }
    }
  }
`;

export const TASK_QUERY = gql`
  query TaskList(
    $business_status: String
    $owner: String
    $fallback_business_status: String
    $fallback_owner: String
    $count: Int
    $offset: Int
  ) {
    primary: TaskList(
      business_status: $business_status
      owner: $owner
      _sort: "-_lastUpdated" 
      _count: $count
      _offset: $offset
    ) {
      ...TaskFields
    }
    fallback: TaskList(
      business_status: $fallback_business_status
      owner: $fallback_owner
      _sort: "-_lastUpdated"
      _count: $count
      _offset: $offset
    ) {
      ...TaskFields
    }
  }
  ${TASK_FIELDS}
`;


export const SINGLE_TASK_QUERY = gql`
  query TaskList(
    $id: String
  ) {
    primary: TaskList(
      _id: $id
    ) {
      ...TaskFields
    }
  }
  ${TASK_FIELDS}
`;

export const CONSENT_QUERY = gql`
  query consent($patient: String!) {
    ConsentList(patient: $patient, _count: 10, _offset: 0) {
      resourceType
      id
      identifier {
        system
        value
      }
      status
      category {
        coding {
          system
          code
          display
        }
      }
      patient {
        reference
      }
      dateTime
      provision {
        actor {
          role {
            coding {
              system
              code
              display
            }
          }
          reference {
            reference
          }
        }
      }
    }
  }
`;

export const ESCALATION_AND_REJECTED_QUERY = gql`
query ValueSets {
  documentRejectionReasons: ValueSetList(
    url: "${RECORD_VALUESET_URLS.DOCUMENT_REJECTION_REASON}"
  ) {
    id
    compose {
      include {
        concept {
          code
          display
        }
      }
    }
  }
  documentEscalationReasons: ValueSetList(
    url: "${RECORD_VALUESET_URLS.DOCUMENT_ESCALATION_REASON}"
  ) {
    id
    compose {
      include {
        concept {
          code
          display
        }
      }
    }
  }
  documentLegalEscalationReasons: ValueSetList(
    url: "${RECORD_VALUESET_URLS.DOCUMENT_LEGAL_ESCALATION_REASON}"
  ) {
    id
    compose {
      include {
        concept {
          code
          display
        }
      }
    }
  }
}`;


export const FAMILY_MEMBER_LIST = gql`
    query FamilyMemberHistory($patientId: String!) {
      FamilyMemberHistoryList(patient: $patientId, _sort: "-date") {
        id
        status
        patient {
          reference
        }
        name
        relationship {
          coding {
            code
            display
            system
          }
        }
        deceasedBoolean
        bornDate
        extension: extension {
          url
          valueCode
        }
      }
    }`;
